module.exports = __webpack_public_path__ + "static/optimo_wyjatkowe-00fab37fcc0117329a1060bb352125ea.png";